import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './searchStaffsDialog.module.scss'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import SelectUnique from '@/components/_custom/Selector/selectUnique/selectUnique'
import { SelectOptionDeprecated, SelectOptionsDeprecated } from '@/types/Select'
import ErrorMessage from '@/components/_custom/ErrorMessage/ErrorMessage'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { StaffWithLinks } from '@/types/Staff.ts'

interface SearchStaffsDialogProps {
    open: boolean
    handleClose: () => void
    staffId: number
    staffsListData: StaffWithLinks[]
}

const SearchStaffsDialog: FunctionComponent<SearchStaffsDialogProps> = ({
    open = false,
    handleClose,
    staffId,
    staffsListData
}: SearchStaffsDialogProps) => {
    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    function redirectToStaffProfile(childId: string): void {
        navigate('/staff?profile=' + childId)
        handleClose()
    }

    const selectOptions: SelectOptionsDeprecated = [
        {
            options: staffsListData
                .map((staff: StaffWithLinks): SelectOptionDeprecated => {
                    return {
                        value: staff.id.toString(),
                        name: staff.firstname && staff.lastname ? staff.firstname + ' ' + staff.lastname : staff.email
                    }
                })
                .sort((a: SelectOptionDeprecated, b: SelectOptionDeprecated): number => {
                    return a.name.localeCompare(b.name)
                })
        }
    ]

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('searchStaff')} />
            <DialogBody className={styles.DialogBody}>
                {selectOptions.length > 0 ? (
                    <div className={styles.InputContainer}>
                        <SelectUnique
                            selectOptions={selectOptions}
                            selectValue={staffId.toString()}
                            setSelectValue={redirectToStaffProfile}
                            className={styles.Select}
                            label={t('staffs')}
                        />
                    </div>
                ) : (
                    <ErrorMessage className={styles.Text} error={t('noStaff')} />
                )}
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default SearchStaffsDialog
